var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"heart-bubble",attrs:{"id":"heart-bubble"}},[(this.list.length > 0)?_c('div',{staticClass:"count"},[_vm._v("+"+_vm._s(_vm.count))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }